/*
 * @Description: 
 * @Author: wangying
 * @Date: 2021-10-26 14:36:37
 */


const config = {
  baseurl: "https://gsc.see.org.cn/",
  // baseurl: "http://gsc.see.org.cn/",
};
// export default config;
module.exports = config;
